module.exports = __webpack_public_path__ + "media/images/gallery/constellations/order_layer_on-4e24f13638ccf3388037f6b207ba1d5b.png";